import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { InformationIcon } from '@instacart/ids-core'
import {
  colors,
  fontSize,
  fontWeight,
  spacing,
  Tooltip,
} from '@retailer-platform/shared-components'
import {
  type DomainMessages,
  useDomainMessage,
} from 'domains/partner-pick-devices/utils/domain/intl'

interface PartnerPickDevicesFormRadioGroupProps {
  labelMessageId: DomainMessages
  tooltipMessageId: DomainMessages
}

const labelContainerStyles = css({
  display: 'flex',
  marginBottom: spacing.X16,
})

const labelTextStyles = css({
  color: colors.GRAYSCALE.X50,
  display: 'block',
  fontSize: fontSize.X15,
  fontWeight: fontWeight.SEMIBOLD,
  marginBottom: spacing.X8,
  marginRight: spacing.X4,
})

const tooltipIconStyles = css({
  fill: colors.GRAYSCALE.X50,
})

const radioStyles = css({
  display: 'flex',
  marginBottom: spacing.X36,
})

export const PartnerPickDevicesFormRadioGroup: FunctionComponent<
  PartnerPickDevicesFormRadioGroupProps
> = ({ labelMessageId, tooltipMessageId, children }) => {
  const label = useDomainMessage(labelMessageId)
  const tooltip = useDomainMessage(tooltipMessageId)

  return (
    <div>
      <div css={labelContainerStyles}>
        <span css={labelTextStyles}>{label}</span>

        <Tooltip placement="bottom" target={<InformationIcon css={tooltipIconStyles} />}>
          {tooltip}
        </Tooltip>
      </div>

      <div css={radioStyles}>{children}</div>
    </div>
  )
}
